import { render } from "./DataTableCell.vue?vue&type=template&id=af67032e"
import script from "./DataTableCell.vue?vue&type=script&lang=js"
export * from "./DataTableCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__